import { render, staticRenderFns } from "./FinancialPlanQuickTour.vue?vue&type=template&id=3c63152a"
import script from "./FinancialPlanQuickTour.vue?vue&type=script&lang=js"
export * from "./FinancialPlanQuickTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports